import { FETCH_BASKET_REQUEST_SENT, FETCH_BASKET_SUCCEEDED, SET_BASKET } from './actions.basket';
import {
    CHANGE_DELIVERY_OPTION,
    SUBMIT_DELIVERY_OPTION_SUCCEEDED,
    FETCH_DELIVERY_OPTIONS_SUCCEEDED,
    FETCH_DELIVERY_OPTIONS_REQUEST_SENT,
} from './actions.pickup';
import { computeBasketPrices } from 'modules/basketUtils.js';

export const checkoutReducer = (
    state = {
        basket: null,
        deliveryOptions: [],
        isFetchingBasket: false,
        isFetchingDelivery: false,
        isFetchedBasket: false,
        isFetchedDelivery: false,
        basketPrices: null,
        selectedOption: null,
    },
    action
) => {
    switch (action.type) {
        case SET_BASKET:
            return {
                ...state,
                basket: action.basket,
            };
        case FETCH_BASKET_REQUEST_SENT:
            return {
                ...state,
                isFetchingBasket: true,
                isFetchedBasket: false,
            };
        case FETCH_BASKET_SUCCEEDED:
            return {
                ...state,
                basket: action.basket,
                deliveryOptions: action.deliveryOptions,
                isFetchingBasket: false,
                isFetchedBasket: true,
                isFetchedDelivery: true,
            };
        case FETCH_DELIVERY_OPTIONS_REQUEST_SENT:
            return {
                ...state,
                isFetchingDelivery: true,
                isFetchedDelivery: false,
            };
        case FETCH_DELIVERY_OPTIONS_SUCCEEDED:
            return {
                ...state,
                deliveryOptions: action.deliveryOptions,
                isFetchingDelivery: false,
                isFetchedDelivery: true,
            };
        case SUBMIT_DELIVERY_OPTION_SUCCEEDED:
            return {
                ...state,
                basket: action.basket,
            };
        case CHANGE_DELIVERY_OPTION:
            const basketPrices = computeBasketPrices(
                action.selectedOption,
                state.basket.totalPriceWithoutShipping,
                state.deliveryOptions
            );
            return {
                ...state,
                selectedOption: action.selectedOption,
                basketPrices,
            };
        default:
            return state;
    }
};
